module.exports = __webpack_public_path__ + "img/piece-complete-3.43321377.svg";